module.exports = __webpack_public_path__ + "static/media/tech1.a71161d2.jpg";